<template>
  <v-btn
    :disabled="disabled || loading"
    v-bind="$attrs"
  >
    <v-progress-circular
      v-if="loading"
      class="mr-2"
      color="primary"
      width="3"
      size="20"
      indeterminate
    />
    <slot />
  </v-btn>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    }
  }
}
</script>
